import React from "react";
import PropTypes from "prop-types";

import { RemoveButton } from "../../../../components/Buttons/RemoveButton";

export const ArrayRemoveButton = ({
  arrayHelpers,
  dataArray,
  itemIndex,
  prospectPath,
  updateProspect,
  ...props
}) => (
  <RemoveButton
    onClick={() => {
      if (itemIndex > -1) {
        arrayHelpers.remove(itemIndex);
        const removedArray = [...dataArray];
        removedArray.splice(itemIndex, 1);
        let updatedArray = removedArray.filter(obj => delete obj.id);
        updateProspect({
          [prospectPath]: updatedArray
        });
      }
    }}
    {...props}
  />
);

ArrayRemoveButton.propTypes = {
  /**
   * Array helpers from Formik's FieldArray component
   */
  arrayHelpers: PropTypes.shape({
    remove: PropTypes.func.isRequired,
    push: PropTypes.func,
    insert: PropTypes.func,
    pop: PropTypes.func
  }).isRequired,

  /**
   * Array of data items to be manipulated
   */
  dataArray: PropTypes.array.isRequired,

  /**
   * Index of the item to be removed from the array
   */
  itemIndex: PropTypes.number.isRequired,

  /**
   * Path to the prospect data in the Redux store
   */
  prospectPath: PropTypes.string.isRequired,

  /**
   * Function to update the prospect data in the Redux store
   */
  updateProspect: PropTypes.func.isRequired,

  /**
   * Additional props to be passed to the RemoveButton component
   */
  sx: PropTypes.object,

  /**
   * Button text
   */
  title: PropTypes.string
};
